export default [
  {
    path: "/test/test",
    name: "test",
    component: () => import("@/views/pages/test/test/Test.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Test and Test",
      },
      {
        text: "Test",
        active: true,
      },
    ],
  }
];
